export default "__VITE_ASSET__CIXRP2nC__"